import React from 'react'
import { Link } from 'react-router-dom'

const SessionGameBanner = () => {
    return (
        <div className='flex flex-row gap-4'>
            {/* <div className='w-1/2 border-2 flex flex-row'> */}
            <Link to="/wonder-game" className='w-1/2 bg-[#B0D9B1] flex flex-row p-1 gap-2 rounded-[10px] items-center'>
                <div className='w-2/5'>
                    <img src={require('../assets/yancha-eight-wonder.png')} width={100} alt="home" />
                </div>
                <div className='w-3/5'>
                    <p className='brand-font txt-bold text-[16px] leading-[18px]'>8th Wonder - The Yancha Game</p>
                </div>
            </Link>
            {/* </div> */}

            <Link to="/one-on-one" className='w-1/2 bg-[#F1C27B] flex flex-row p-1 gap-2 rounded-[10px] items-center'>
                <div className='w-2/5'>
                    <img src={require('../assets/yancha-one-on-one.png')} width={100} alt="home" />
                </div>
                <div className='w-3/5'>
                    <p className='brand-font txt-bold text-[16px] leading-[18px]'>Yancha One-on-One Sessions</p>
                </div>
            </Link>


        </div>
    )
}

export default SessionGameBanner